import React, { useEffect, useState } from "react";
import {
  Box,
  Sheet,
  Table,
  Button,
  Input,
  Option,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  FormControl,
  FormLabel,
  Stack,
  Select,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, PageTitle } from "../../../components";

import {
  fetchAgentStaffReset,
  fetchAgentStaffRequest,
  addAgentStaffReset,
  addAgentStaffRequest,
  viewAgentStaffRequest,
  viewAgentStaffReset,
  rejectAgentStaffRequest,
  rejectAgentStaffReset,
  approveAgentStaffRequest,
  approveAgentStaffReset,
  deactivateAgentStaffRequest,
  activateAgentStaffRequest,
  deactivateAgentStaffReset,
  activateAgentStaffReset,
  unblockAgentRequest,
  unblockAgentReset,
  resetAgentPasswordRequest,
  resetAgentPasswordReset,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  LockOpenOutlined,
  PersonAddOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";

const AgentStaffPage = ({
  loginResult,

  agentStaffListStatus,
  agentStaffListResult,
  agentStaffListErrorMessage,

  addAgentStaffStatus,
  addAgentStaffResult,
  addAgentStaffErrorMessage,

  rejectAgentStaffStatus,
  rejectAgentStaffResult,
  rejectAgentStaffErrorMessage,

  approveAgentStaffStatus,
  approveAgentStaffResult,
  approveAgentStaffErrorMessage,

  activateAgentStaffStatus,
  activateAgentStaffResult,
  activateAgentStaffErrorMessage,

  deactivateAgentStaffStatus,
  deactivateAgentStaffResult,
  deactivateAgentStaffErrorMessage,

  unblockAgentStatus,
  unblockAgentResult,
  unblockAgentErrorMessage,

  resetAgentPasswordStatus,
  resetAgentPasswordResult,
  resetAgentPasswordErrorMessage,
}) => {
  const dispatch = useDispatch();
  const { state } = useLocation();

  const { agent_id } = state;

  const [agentData, setAgentData] = useState([]);

  const [formModal, setFormModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [fname, setFName] = useState("");
  const [sname, setSName] = useState("");
  const [lname, setLName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [agentStaff_id, setAgentStaffID] = useState("");
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(0);
  const [id, setId] = useState(0);

  function CreateItems(title: String, value: String) {
    return { title, value };
  }
  const rows = [
    CreateItems("First Name", fname),
    CreateItems("Second Name", sname),
    CreateItems("Last Name", lname),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Locked", 4: "Rejected", 5: "Pending" }[
        status
      ],
    ),
    CreateItems("Email", email),
    CreateItems("Mobile", mobile),
    CreateItems("Remark", remark),
  ];

  useEffect(() => {
    if (agentStaffListStatus === STATUS.SUCCESS) {
      setId(agentStaffListResult[0].id);
      setFName(agentStaffListResult[0].first_name);
      setSName(agentStaffListResult[0].middle_name);
      setLName(agentStaffListResult[0].last_name);
      setEmail(agentStaffListResult[0].email);
      setMobile(agentStaffListResult[0].mobile_num);
      setStatus(agentStaffListResult[0].status);
      setRemark(agentStaffListResult[0].remark);
      setTimeout(() => {
        dispatch(viewAgentStaffReset());
      }, 2000);
    }

    if (agentStaffListStatus === STATUS.SUCCESS) {
      setAgentData(agentStaffListResult);
      // dispatch(fetchAgentStaffReset())
    } else if (agentStaffListStatus === STATUS.ERROR) {
      setAgentData([]);
      toast.error(agentStaffListErrorMessage);
      dispatch(fetchAgentStaffReset());
    }

    if (addAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("AgentStaff added successful");
      setFormModal(false);
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
      dispatch(addAgentStaffReset());
    } else if (addAgentStaffStatus === STATUS.ERROR) {
      toast.error(addAgentStaffErrorMessage);
      dispatch(addAgentStaffReset());
    }

    if (approveAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("AgentStaff approved successful");
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
      dispatch(approveAgentStaffReset());
    } else if (approveAgentStaffStatus === STATUS.ERROR) {
      toast.error(approveAgentStaffErrorMessage);
      dispatch(approveAgentStaffReset());
    }

    if (rejectAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("AgentStaff rejected successful");
      setRejectModal(false);
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
      dispatch(rejectAgentStaffReset());
    } else if (rejectAgentStaffStatus === STATUS.ERROR) {
      toast.error(rejectAgentStaffErrorMessage);
      dispatch(rejectAgentStaffReset());
    }

    if (activateAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff activated successful");
      // setRejectModal(false);
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
      dispatch(activateAgentStaffReset());
    } else if (activateAgentStaffStatus === STATUS.ERROR) {
      toast.error(activateAgentStaffErrorMessage);
      dispatch(activateAgentStaffReset());
    }

    if (deactivateAgentStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff deactivated successful");
      setDeactivateModal(false);
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
      dispatch(deactivateAgentStaffReset());
    } else if (activateAgentStaffStatus === STATUS.ERROR) {
      toast.error(deactivateAgentStaffErrorMessage);
      dispatch(deactivateAgentStaffReset());
    }

    if (unblockAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent user unblocked  successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(unblockAgentReset());
    } else if (unblockAgentStatus === STATUS.ERROR) {
      toast.error(unblockAgentErrorMessage);
      dispatch(unblockAgentReset());
    }

    if (resetAgentPasswordStatus === STATUS.SUCCESS) {
      toast.success("Agent user password reset successful");
      dispatch(viewAgentStaffRequest(loginResult.token, { id: agentStaff_id }));
      dispatch(resetAgentPasswordReset());
    } else if (resetAgentPasswordStatus === STATUS.ERROR) {
      toast.error(resetAgentPasswordErrorMessage);
      dispatch(resetAgentPasswordReset());
    }
  });

  useEffect(() => {
    dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
  }, [agent_id, dispatch, loginResult]);

  /* -------- actions ----------- */

  const approveAgentStaff = () => {
    const data = {
      id: id,
    };
    dispatch(approveAgentStaffRequest(loginResult.token, data));
  };

  const rejectAgentStaff = () => {
    const data = {
      id: id,
      remark: remark,
    };
    dispatch(rejectAgentStaffRequest(loginResult.token, data));
  };

  // const openReject = (details) => {
  //   setRejectModal(true);
  //   setFName(details.first_name);
  //   setAgentStaffID(details.id);
  // };

  // const activateAgent = (details) => {
  //   const data = { id: details.id };
  //   dispatch(activateAgentStaffRequest(loginResult.token, data));
  // };

  const deactivateAgent = () => {
    const data = {
      id: agentStaff_id,
      remark: remark,
    };
    dispatch(deactivateAgentStaffRequest(loginResult.token, data));
  };

  // const openDeactivateModal = (details) => {
  //   setDeactivateModal(true);
  //   setFName(details.first_name);
  //   setAgentStaffID(details.id);
  // };

  const openAddForm = () => {
    setFName("");
    setSName("");
    setLName("");
    setMobile("");
    setEmail("");
    setFormModal(true);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (fname && sname && lname && email && mobile) {
      const data = {
        id: agent_id,
        first_name: fname,
        middle_name: sname,
        last_name: lname,
        email: email,
        mobile_num: mobile,
      };
      dispatch(addAgentStaffRequest(loginResult.token, data));
    } else {
      toast.error("Please fill all required information");
    }
  };

  const activateAgentStaff = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(activateAgentStaffRequest(loginResult.token, data));
  };

  const unblockAgent = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(unblockAgentRequest(loginResult.token, data));
  };

  const resetAgentPassword = () => {
    const data = {
      id: agentStaff_id,
    };
    dispatch(resetAgentPasswordRequest(loginResult.token, data));
  };

  const checkLoading = () => {
    if (
      agentStaffListStatus === STATUS.LOADING ||
      addAgentStaffStatus === STATUS.LOADING ||
      approveAgentStaffStatus === STATUS.LOADING ||
      rejectAgentStaffStatus === STATUS.LOADING ||
      activateAgentStaffStatus === STATUS.LOADING ||
      deactivateAgentStaffStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"Manage Agent Staffs"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          // width: { xs: 'auto', md: '30%' },
          justifyContent: "space-between",
        }}
      >
        {/* only sales officer can add agent user */}
        {loginResult.role === 3 && !agentStaffListResult && (
          <Button
            startDecorator={<PersonAddOutlined />}
            color="success"
            sx={{ width: "auto" }}
            onClick={openAddForm}
          >
            Add new Agent Staff
          </Button>
        )}
        {/* ----- only admin can approve, reject, activate and deactivate agent user */}
        {loginResult.role === 2 &&
          status != 4 &&
          (status === 5 ? (
            <>
              <Button
                color="success"
                startDecorator={<TaskAltOutlined />}
                onClick={approveAgentStaff}
              >
                Approve
              </Button>
              <Button
                color="warning"
                startDecorator={<BlockOutlined />}
                onClick={() => setRejectModal(true)}
              >
                Reject
              </Button>
            </>
          ) : status === 1 ? (
            <>
              <Button
                color="danger"
                startDecorator={<DoNotDisturbOn />}
                onClick={() => setDeactivateModal(true)}
              >
                Deactivate
              </Button>
            </>
          ) : (
            <Button
              color="success"
              startDecorator={<CheckCircle />}
              onClick={activateAgentStaff}
            >
              Activate
            </Button>
          ))}

        {/* ---- only sale officer can edit ------ */}
        {status === 1 && loginResult.role === 3 && (
          <Button
            color="primary"
            startDecorator={<EditOutlined />}
            onClick={() => setFormModal(true)}
          >
            Edit
          </Button>
        )}

        {/* --- only admin can unlock agent user ----- */}
        {loginResult.role === 1 && status === 3 && (
          <Button
            color="danger"
            startDecorator={<LockOpenOutlined />}
            onClick={unblockAgent}
          >
            UnLock
          </Button>
        )}

        {/* ---- only admin can reser password */}
        {loginResult.role === 1 && status === 1 && (
          <Button
            color="neutral"
            // startDecorator={<EditOutlined />}
            onClick={resetAgentPassword}
          >
            Reset Password
          </Button>
        )}
      </Sheet>

      {/* Details */}
      <Box
        sx={{
          gap: 2,
          display: "flex",
          flexDirection: "column",
          width: { xs: "unset", md: "70%" },
        }}
      >
        {/* client details */}
        <Sheet
          className="OrderTableContainer"
          variant="outlined"
          sx={{
            // display: 'flex',
            // width: '100%',
            borderRadius: "sm",
            flexShrink: 1,
            overflow: "auto",
            minHeight: 0,
          }}
        >
          <Table
            // aria-label="striped table"
            // stripe="odd"
            // variant="soft"
            aria-labelledby="tableTitle"
            stickyHeader
            hoverRow
            sx={{
              "--TableCell-headBackground":
                "var(--joy-palette-background-level2)",
              "--Table-headerUnderlineThickness": "1px",
              "--TableRow-hoverBackground":
                "var(--joy-palette-background-level1)",
              "--TableCell-paddingY": "4px",
              "--TableCell-paddingX": "8px",
            }}
          >
            <thead>
              <tr>
                <th style={{ width: "40%", fontSize: 18 }}>
                  Agent Staff Details
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>
                    <b>{row.title}</b>
                  </td>
                  <td>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Sheet>
      </Box>

      {/* ------ Modal form for add and edit agentStaff details ------ */}
      <Modal open={formModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              top: "60px",
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose variant="outlined" onClick={() => setFormModal(false)} />
          <DialogTitle>{"Add Agent Staff"}</DialogTitle>
          <DialogContent>
            Please enter agentStaff details correct.
          </DialogContent>
          <Stack component="form" onSubmit={submitForm} gap={2} sx={{ mt: 2 }}>
            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* first name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>First Name</FormLabel>
                <Input
                  type="text"
                  value={fname}
                  onChange={(e) => setFName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </FormControl>

              {/* second name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Middle Name</FormLabel>
                <Input
                  type="text"
                  value={sname}
                  onChange={(e) => setSName(e.target.value)}
                  placeholder="Enter your second name"
                />
              </FormControl>

              {/* last name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Last Name</FormLabel>
                <Input
                  type="text"
                  value={lname}
                  onChange={(e) => setLName(e.target.value)}
                  placeholder="Enter your third name"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* mobile number */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Mobile number</FormLabel>
                <Input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter agentStaff phone number"
                />
              </FormControl>

              {/* email */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter agentStaff email"
                />
              </FormControl>
            </Stack>

            <Stack gap={4} sx={{ mt: 2 }}>
              <Button type="submit" fullWidth>
                Submit
              </Button>
            </Stack>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject AgentStaff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectAgentStaff}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate Agent Staff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateAgent}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ agentStaff, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    agentStaffListResult,
    agentStaffListStatus,
    agentStaffListErrorMessage,

    addAgentStaffStatus,
    addAgentStaffResult,
    addAgentStaffErrorMessage,

    rejectAgentStaffStatus,
    rejectAgentStaffResult,
    rejectAgentStaffErrorMessage,

    approveAgentStaffStatus,
    approveAgentStaffResult,
    approveAgentStaffErrorMessage,

    activateAgentStaffStatus,
    activateAgentStaffResult,
    activateAgentStaffErrorMessage,

    deactivateAgentStaffStatus,
    deactivateAgentStaffResult,
    deactivateAgentStaffErrorMessage,

    unblockAgentStatus,
    unblockAgentResult,
    unblockAgentErrorMessage,

    resetAgentPasswordStatus,
    resetAgentPasswordResult,
    resetAgentPasswordErrorMessage,
  } = agentStaff;

  return {
    loginResult,

    agentStaffListStatus,
    agentStaffListResult,
    agentStaffListErrorMessage,

    addAgentStaffStatus,
    addAgentStaffResult,
    addAgentStaffErrorMessage,

    rejectAgentStaffStatus,
    rejectAgentStaffResult,
    rejectAgentStaffErrorMessage,

    approveAgentStaffStatus,
    approveAgentStaffResult,
    approveAgentStaffErrorMessage,

    activateAgentStaffStatus,
    activateAgentStaffResult,
    activateAgentStaffErrorMessage,

    deactivateAgentStaffStatus,
    deactivateAgentStaffResult,
    deactivateAgentStaffErrorMessage,

    unblockAgentStatus,
    unblockAgentResult,
    unblockAgentErrorMessage,

    resetAgentPasswordStatus,
    resetAgentPasswordResult,
    resetAgentPasswordErrorMessage,
  };
};

export default connect(mapStateToProps, {})(AgentStaffPage);
